export default __webpack_public_path__ + "static/eth-global-02ece42c8bd91eba0770c3bea351d6a9.svg";